import { parseApiError } from '@sophocles/utils/apiErrors';

export function handleFormErrorResponse(response, setFieldError, setNonFieldError) {
  if (!response?.data || response.status !== 400) {
    return;
  }

  const { fieldErrors, nonFieldMessages } = parseApiError(response.data, { genericMessage: null });

  Object.entries(fieldErrors).forEach(([field, messages]) => setFieldError(field, messages.join(', ')));
  if (nonFieldMessages.length > 0) {
    setNonFieldError(nonFieldMessages.join(', '));
  }
}
